export default "__VITE_ASSET__B02Iv85R__"